module.exports = __webpack_public_path__ + "static/media/most-active-month-video.a72045e0.mp4";